import * as tus from "tus-js-client";

export const uploadToBunnyTus = ({
  file,
  videoId,
  libraryId,
  signature,
  expires,
  title,
  onProgress,
}) => {
  return new Promise((resolve, reject) => {
    const upload = new tus.Upload(file, {
      endpoint: "https://video.bunnycdn.com/tusupload", // ✅ CORRECT
      retryDelays: [0, 3000, 5000, 10000, 20000],
      headers: {
        AuthorizationSignature: signature,
        AuthorizationExpire: expires,
        VideoId: videoId,
        LibraryId: libraryId,
      },
      metadata: {
        filetype: file.type,
        title: title,
      },
      onProgress(bytesUploaded, bytesTotal) {
        const percent = Math.floor((bytesUploaded / bytesTotal) * 100);
        if (onProgress) onProgress(percent);
      },
      onSuccess() {
        resolve({
          videoPublicId: videoId,
          // videoPlaybackUrl: `https://iframe.mediadelivery.net/embed/${libraryId}/${videoId}`,
          videoCloudResourceType: "video",
          videoFormat: file.name.split(".").pop(),
        });
      },
      onError(error) {
        reject(error);
      },
    });

    upload.findPreviousUploads().then((prev) => {
      upload.start();
    });
  });
};
